import { render, staticRenderFns } from "./ReleaseTable.vue?vue&type=template&id=a78e96f0&scoped=true&"
import script from "./ReleaseTable.vue?vue&type=script&lang=js&"
export * from "./ReleaseTable.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseTable.vue?vue&type=style&index=0&id=a78e96f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78e96f0",
  null
  
)

export default component.exports